var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-name" }, [
          _vm._v("\n            Add HR Team\n            "),
          _c(
            "button",
            {
              staticClass: "back_button btn btn-primary pull-right",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.buttonBack.apply(null, arguments)
                }
              }
            },
            [_vm._v("Back")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("form", { attrs: { id: "benefitForm" } }, [
            _c(
              "div",
              { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
              [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "name" } }, [_vm._v("Name")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.name,
                          expression: "name"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", id: "name", placeholder: "Name" },
                      domProps: { value: _vm.name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.name = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("font", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.nameError))
                    ])
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
              [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "post" } }, [_vm._v("Post")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.post,
                          expression: "post"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", id: "post", placeholder: "Post" },
                      domProps: { value: _vm.post },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.post = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("font", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.postError))
                    ])
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
              [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "teamdesignation" } }, [
                      _vm._v("Team Designation")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.teamDesignation,
                          expression: "teamDesignation"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        id: "teamDesignation",
                        placeholder: "Team Designation"
                      },
                      domProps: { value: _vm.teamDesignation },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.teamDesignation = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("font", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.teamDesignationError))
                    ])
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12" },
              [
                _c("label", { attrs: { for: "image" } }, [
                  _vm._v("Upload Image")
                ]),
                _vm._v(" "),
                [
                  _c(
                    "div",
                    { attrs: { id: "app" } },
                    [
                      _c("vue-dropzone", {
                        ref: "dropzone",
                        attrs: {
                          id: "drop1",
                          options: _vm.dropzoneOptions,
                          destroyDropzone: false,
                          headers: _vm.dropzoneOptions.headers,
                          name: "file"
                        },
                        on: {
                          "vdropzone-removed-file": _vm.removedSelectedFile,
                          "vdropzone-success": _vm.vfileSuccess
                        }
                      }),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _c("strong", {
                          staticClass: "error text-danger",
                          attrs: { id: "uploadErrorMsg" }
                        })
                      ])
                    ],
                    1
                  )
                ]
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12" },
              [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6" },
                  [
                    _c("vue-croppie", {
                      ref: "croppieRef",
                      attrs: {
                        id: "vuecrop",
                        viewport: { width: 276, height: 312, type: "square" },
                        boundary: { width: 286, height: 322 },
                        enableResize: false
                      },
                      on: { result: _vm.result, update: _vm.update }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn-croppie",
                        attrs: {
                          id: "rotateAnti",
                          type: "button",
                          title: "Rotate Left"
                        },
                        on: {
                          click: function($event) {
                            return _vm.rotate(-90)
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-repeat",
                          attrs: { "aria-hidden": "true" }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn-croppie",
                        attrs: {
                          id: "rotateClock",
                          type: "button",
                          title: "Rotate Right"
                        },
                        on: {
                          click: function($event) {
                            return _vm.rotate(90)
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-undo",
                          attrs: { "aria-hidden": "true" }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn-croppie",
                        attrs: { id: "crop", type: "button", title: "Crop" },
                        on: {
                          click: function($event) {
                            return _vm.crop()
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-crop",
                          attrs: { "aria-hidden": "true" }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("img", { attrs: { src: _vm.cropped, width: "200" } }),
                    _vm._v(" "),
                    _c("font", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.cropError))
                    ])
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
            }),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" },
              [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "description" } }, [
                      _vm._v("Description")
                    ]),
                    _vm._v(" "),
                    _c("tinymce", {
                      ref: "tm",
                      attrs: {
                        plugins: [
                          "advlist autolink lists link image charmap print preview hr anchor pagebreak",
                          "searchreplace wordcount visualblocks visualchars code fullscreen",
                          "insertdatetime media nonbreaking save table contextmenu directionality",
                          "template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample"
                        ],
                        id: "description"
                      },
                      model: {
                        value: _vm.description,
                        callback: function($$v) {
                          _vm.description = $$v
                        },
                        expression: "description"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("font", { staticClass: "text-danger" }, [
                  _vm._v(_vm._s(_vm.descriptionError))
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
              [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "name" } }, [_vm._v("Quote")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.quote,
                          expression: "quote"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        id: "quote",
                        placeholder: "Quote"
                      },
                      domProps: { value: _vm.quote },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.quote = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("font", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.quoteError))
                    ])
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12" },
              [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "quoteWriterName" } }, [
                      _vm._v("Quote Writer Name")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.quoteWriterName,
                          expression: "quoteWriterName"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        id: "quoteWriterName",
                        placeholder: "Quote Writer Name"
                      },
                      domProps: { value: _vm.quoteWriterName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.quoteWriterName = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("font", { staticClass: "text-danger" }, [
                      _vm._v(_vm._s(_vm.quoteWriterNameError))
                    ])
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix" }),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix" }),
            _vm._v(" "),
            _c("div", { staticClass: "row clearfix" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12" },
              [
                _c("div", { staticClass: "button-demo" }, [
                  _c("input", {
                    staticClass: "btn btn-primary",
                    attrs: {
                      id: "addBenifitBtn",
                      type: "submit",
                      value: "Save"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.addHrTeam()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "btn btn-primary",
                    attrs: {
                      id: "addAndContinueBenifitBtn",
                      type: "submit",
                      value: "Save and Continue"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.addHrTeam((_vm.flag = "Save and Continue"))
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "back_button btn btn-primary",
                    attrs: {
                      id: "CancelBenifit",
                      type: "submit",
                      value: "Cancel"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.buttonBack.apply(null, arguments)
                      }
                    }
                  })
                ])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row clearfix" }, [
      _c("div", { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" }, [
        _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { id: "alertError" } },
          [
            _c(
              "button",
              {
                staticClass: "close",
                attrs: {
                  type: "button",
                  "data-dismiss": "alert",
                  "aria-label": "Close"
                }
              },
              [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
            ),
            _vm._v(" "),
            _c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c92f6b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c92f6b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/meethrteam/AddHrTeam.vue
// module id = null
// module chunks = 